import React from 'react'
import { Box, Typography, Card, CardContent } from '@mui/material'
import Grid from '@mui/material/Grid2';
import AutomateImg from '../../assets/AutomateImg.png'
import SetUpAlerts from '../../assets/SetUpAlerts.png'
import Monitor from '../../assets/Monitor.png'
import Inventory from '../../assets/Inventory.png'

function Automate() {

    const features = [
        {
            title: "Set Up Alerts",
            description: "Receive low-stock and reorder notifications automatically",
            image: SetUpAlerts 
        },
        {
            title: "Monitor & Optimize",
            description: "Use analytics to forecast demand and improve efficiency.",
            image: Monitor, 
        },
        {
            title: "Add Your Inventory",
            description: "Import products easily from your existing system",
            image: Inventory, 
        },
    ];


    return (
        <Box sx={{ backgroundColor: '#F9FBFC',overflow: 'hidden' }}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
                <Box sx={{ width: { xs: '80%', sm: '30%' }, ml: { xs: '0%', sm: '5%' }, display: 'flex', flexDirection: 'column', mt: { xs: '0%', sm: '10%' }, padding: '50px' }}>
                    <Typography sx={{ color: '#00BFA5', fontFamily: 'poppins', fontSize: '20px' }}>Services</Typography>
                    <Typography sx={{ fontWeight: 'bold', fontSize: '30px' }}>Automate Stock Tracking</Typography>
                    <Typography sx={{ fontSize: '15px', fontFamily: 'Sora', color: '#6C87AE' }}>
                        Get real-time updates on stock levels and movements. Set Up Alerts – Receive low-stock and reorder notifications automatically.
                    </Typography>
                </Box>
                <Box sx={{ width: { xs: '100%', sm: '50%' }, padding: '20px', ml: { xs: '0%', sm: '5%' } }}>
                    <img src={AutomateImg} alt="Manufacturing" style={{ width: '85%', height: 'auto' }} />
                </Box>
            </Box>
            <Grid container spacing={2} justifyContent="center" sx={{ p: 4, backgroundColor: "#F8FAFC" }}>
                {features.map((feature, index) => (
                    <Grid item key={index} width='300px' >
                        <Card sx={{ textAlign: "center", boxShadow: 0.2, borderRadius: 2 }}>
                            <img src={feature.image} alt={feature.title} style={{ width: "200px",height:'auto',minHeight:"200px", margin: "auto", marginBottom: 12 }} />
                            <CardContent>
                                <Typography variant="h6" fontWeight="bold">
                                    {feature.title}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {feature.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}

export default Automate